import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

export enum EmailsSuspendStates {
  EmailsEnabled = 'EmailsEnabled',
  CampaignsSuspended = 'CampaignsSuspended',
  EmailsSuspended = 'EmailsSuspended',
}

export const EmailsSuspendStatesMap = {
  [EmailsSuspendStates.EmailsEnabled]: 0,
  [EmailsSuspendStates.CampaignsSuspended]: 1,
  [EmailsSuspendStates.EmailsSuspended]: 2,
};
export const stateToValue = (
  enableEmails: boolean,
  suspendCampaigns: boolean,
  unSuspendCampaigns: boolean,
  stopEmails: boolean,
): EmailsSuspendStates => {
  if (suspendCampaigns && stopEmails) {
    return EmailsSuspendStates.EmailsEnabled;
  } else if (unSuspendCampaigns && stopEmails) {
    return EmailsSuspendStates.CampaignsSuspended;
  } else if (enableEmails) {
    return EmailsSuspendStates.EmailsSuspended;
  }
};

@Component({
  selector: 'app-suspend-emails',
  templateUrl: './suspend-emails.component.html',
  styleUrls: ['./suspend-emails.component.scss'],
})
export class SuspendEmailsComponent implements OnInit {
  currentState: EmailsSuspendStates;

  states = EmailsSuspendStates;

  inputForm: FormGroup;

  constructor() {
  }

  get value(): string {
    return this.inputForm.get('enableEmails').value;
  }

  ngOnInit(): void {
    this.inputForm.addControl(
      'enableEmails',
      new FormControl(this.currentState),
    );
  }
}
